module.exports = __webpack_public_path__ + "static/img/faurecia.ed7b300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companys/faurecia.png
// module id = vX8W
// module chunks = 0